export const initialValues = {
  customer: {
    email: '',
    phone: '',
    createAccount: false,
    password: '',
    billingAddressSame: true,
    deliveryAddress: {
      gender: 'male',
      firstName: '',
      lastName: '',
      postalCode: '',
      city: '',
      street: '',
      companyName: '',
      country: 'NL',
      countryOption: 'netherlands',
      state: '',
      houseNumber: '',
      houseNumberSuffix: ''
    },
    billingAddress: {
      gender: 'mr',
      firstName: '',
      lastName: '',
      postalCode: '',
      city: '',
      street: '',
      companyName: '',
      country: 'NL',
      countryOption: 'netherlands',
      state: '',
      houseNumber: '',
      houseNumberSuffix: ''
    }
  },
  orderMeta: {
    wrapping: {
      wrapping: false,
      text: ''
    },
    newsletterSignup: false,
    message: '',
    delivery: null
  },
  acceptTermsAndConditions: false
}
